import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M7 15v-6","key":"svg-1"}],["path",{"d":"M15.5 12h3","key":"svg-2"}],["path",{"d":"M17 10.5v3","key":"svg-3"}],["path",{"d":"M10 10.5a1.5 1.5 0 0 1 3 0c0 .443 -.313 .989 -.612 1.393l-2.388 3.107h3","key":"svg-4"}]]

const IconRating12Plus = createReactComponent('outline', 'rating-12-plus', 'Rating12Plus', __iconNode);

export default IconRating12Plus;